"use client";

import { c as _c } from "react/compiler-runtime";
import { readStoredCompactViewPreference, writeStoredCompactViewPreference } from "@/lib/workflow/layoutPolicy";
import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
const CompactViewContext = createContext(false);
const CompactViewSetterContext = createContext<(v: boolean) => void>(() => {});
interface CompactViewProviderProps {
  children: React.ReactNode;
  value?: boolean;
  defaultValue?: boolean;
  persist?: boolean;
  onChange?: (value: boolean) => void;
}
export function CompactViewProvider(t0) {
  const $ = _c(13);
  const {
    children,
    value,
    defaultValue: t1,
    persist: t2,
    onChange
  } = t0;
  const defaultValue = t1 === undefined ? true : t1;
  const persist = t2 === undefined ? true : t2;
  const isControlled = value !== undefined;
  const [internalValue, setInternalValue] = useState(defaultValue);
  let t3;
  let t4;
  if ($[0] !== defaultValue) {
    t3 = () => {
      setInternalValue(readStoredCompactViewPreference(defaultValue));
    };
    t4 = [defaultValue];
    $[0] = defaultValue;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  const isCompact = isControlled ? value : internalValue;
  let t5;
  if ($[3] !== isControlled || $[4] !== onChange || $[5] !== persist) {
    t5 = nextValue => {
      if (!isControlled) {
        setInternalValue(nextValue);
      }
      if (persist) {
        writeStoredCompactViewPreference(nextValue);
      }
      onChange?.(nextValue);
    };
    $[3] = isControlled;
    $[4] = onChange;
    $[5] = persist;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const toggle = t5;
  let t6;
  if ($[7] !== children || $[8] !== toggle) {
    t6 = <CompactViewSetterContext.Provider value={toggle}>{children}</CompactViewSetterContext.Provider>;
    $[7] = children;
    $[8] = toggle;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isCompact || $[11] !== t6) {
    t7 = <CompactViewContext.Provider value={isCompact}>{t6}</CompactViewContext.Provider>;
    $[10] = isCompact;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
export function useCompactView() {
  return useContext(CompactViewContext);
}
export function useSetCompactView() {
  return useContext(CompactViewSetterContext);
}